import { ActionTab, StateLogbook } from "../types"

export const changeTab = (state: StateLogbook, payload: ActionTab): StateLogbook => {
    return { ...state, tab: payload.value }
}